module.exports = __webpack_public_path__ + "img/m_box3_img.291d9394.png";